module.exports = "/_next/static/images/tennisIconActive@3x-b48339d9e7d7cff1e085eb317f77406e.png";